var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"show":_vm.isOpenLocal,"scrollable":"","header-classes":"bg-primary p-2 flex items-center","size":"lg"},on:{"update:show":function($event){_vm.isOpenLocal=$event}}},[_c('h6',{staticClass:"modal-title text-black font-semibold"},[_vm._v("Add Achievements")])])
}
var staticRenderFns = []

export { render, staticRenderFns }